import React from "react";
import Image_lab from "../Assets/lab_.jpg";
import "./overviewextend.css";

const OverviewExtend = () => {
    return (
        <section className="ovext-section">
            <div className="ovext-grid">

                
                <div className="ovext-image-panel">
                    <img src={Image_lab} alt="ASAVA Pharmaceutical Lab" />
                    <div className="ovext-image-gradient" />
                    <div className="ovext-image-tag">Our Vision</div>
                </div>

                
                <div className="ovext-content-panel">
                    <div className="ovext-bg-letter">A</div>

                    <div className="ovext-eyebrow">About Asava</div>

                    <h2 className="ovext-heading">
                        Dedicated to<br />
                        <span>Patient Well-being</span>
                    </h2>

                    <div className="ovext-divider" />

                    <p className="ovext-text">
                        At ASAVA Pharmaceuticals, we prioritize the well-being of our patients
                        by not only treating their conditions but also improving their overall
                        quality of life. Our comprehensive portfolio spans various fields,
                        including innovative treatments for a wide range of health conditions.
                    </p>

                    <div className="ovext-quote">
                        <p>
                            "Better health starts with accessible, compassionate care —
                            regardless of socio-economic status."
                        </p>
                    </div>

                    <p className="ovext-text">
                        We are deeply committed to social responsibility, conducting initiatives
                        like providing free pathological tests for orphans to ensure early
                        diagnosis and treatment. As we expand, our focus on accessibility and
                        affordability continues to guide every aspect of our work.
                    </p>

                   
                    <div className="ovext-pillars">
                        <div className="ovext-pillar">
                            <div className="ovext-pillar-icon">⚗️</div>
                            <div className="ovext-pillar-title">Innovation</div>
                            <div className="ovext-pillar-desc">Advanced manufacturing & R&D</div>
                        </div>
                        <div className="ovext-pillar">
                            <div className="ovext-pillar-icon">🤝</div>
                            <div className="ovext-pillar-title">Accessibility</div>
                            <div className="ovext-pillar-desc">Affordable care for all</div>
                        </div>
                        <div className="ovext-pillar">
                            <div className="ovext-pillar-icon">❤️</div>
                            <div className="ovext-pillar-title">Compassion</div>
                            <div className="ovext-pillar-desc">Community-first initiatives</div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    );
};

export default OverviewExtend;